import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=2b9682b3&scoped=true&"
import script from "./AppointmentsList.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsList.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsList.vue?vue&type=style&index=0&id=2b9682b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9682b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VImg,VList,VToolbar})
